import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export interface SubStep {
    name: string;
    preText: string;
    detailList: {icon: string; title: string; paragraph: string}[];
    afterText: string;
    btnText: string;
    btnHref: string;
}

@Component
export default class EpicStepDetail extends Vue {
    @Prop({ default: 1})
    public stepNo!: number;

    @Prop({ default: '#ECF8FA'})
    public bgColor!: string;

    @Prop({ default: false})
    public reverse!: boolean;

    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/step1-img.png'})
    public graphic!: string;

    @Prop({ default: 'Prepare for Selling'})
    public stepName!: string;
    @Prop({ default: function() {
        return [{
                name: 'Step 1: Know Housing Market',
                preText: 'Understand wether the market is seller’s market or buyer’s market, and decide to sell the house in a right season.',
                detailList: [{
                    icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/icon1-1.png',
                    title: 'Seller’s Market',
                    paragraph: 'Lots of people are looking for houses while few houses are for sale.'
                }, {
                    icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/icon1-2.png',
                    title: 'Buyer’s Market',
                    paragraph: 'Lots of homes for sale but not many people are buying them.'
                }, {
                    icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/icon1-3.png',
                    title: 'Warm Season',
                    paragraph: 'Warm seasons like spring and summer have better house selling activities than cold seasons'
                }],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 2: Know The Finance',
                preText: 'Before you sell your property, there are some finance knowledge you should understand',
                detailList: [{
                    icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/icon2-1.png',
                    title: 'Discharge Mortgage ',
                    paragraph: 'When you plan to sell a house but don’t want to buy an new one, your mortgage turns to discharge mortgage, you need to pay penalty to lender'
                }, {
                    icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/icon2-2.png',
                    title: 'Portable Mortgage',
                    paragraph: 'When you sell your old house to buy a new one, you can simply ask your lender to change the mortgage plan without penalty '
                }, {
                    icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/icon2-3.png',
                    title: 'Capital Gains Tax',
                    paragraph: `If you rent your property to tenants, or you are selling your vacation or investment house,
                     you owe capital gain tax that generated from your property profits.`
                }],
                afterText: 'RIFO provide professional finance services to solve any finance problems relative to your selling activity.',
                btnText: '',
                btnHref: ''
            }, {
                name: 'Step 3: Meet An RIFO  Real Estate Agent',
                preText: `RIFO have thousands of experienced real estate agents to help you maximize your property value,
                 please do not hesitate to schedule an real estate agent from us`,
                detailList: null,
                afterText: '',
                btnText: 'Contact Us',
                btnHref: '/contact-us'
            }
        ];
    } })
    public detail!: SubStep[];



}
